import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import { SideMenuContainer } from "../component/styled";

const SideMenu = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { url } = useOutletContext();

  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    setCurrentPath(location.pathname.split("/").pop());
  }, [location]);

  return (
    <SideMenuContainer>
      <h2 onClick={() => navigate(`/shop/mypage`)}>마이페이지</h2>
      {tabs.map((tab) => (
        <div className="section">
          <p>{tab.label}</p>
          <ul>
            {tab.items.map((item) => (
              <li
                className={currentPath === item.key ? "active" : "inactive"}
                onClick={() => navigate(`/shop/mypage/${item.key}`)}>
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </SideMenuContainer>
  );
};

export default SideMenu;
